import React from "react";

export const SdgsWheel: React.FC = () => (
  <svg width={1285.49} height={1280.92} viewBox="0 0 1285.49 1280.92">
    <g>
      <path
        className="background"
        id="sdg_one"
        d="M664.73,.47c95.67-5.32,193.45,35.8,193.45,35.8l-100.31,261.74c-40.75-16.24-91.81-17.68-91.81-17.68L664.73,.47Z"
        fill="#e5243b"
        fillOpacity="0.8"
      />
      <path d="M755.64,56.89v80h-12.11V69h-.47l-19.14,12.5v-11.56l19.96-13.05h11.76Z" fill="#f3f4ff" />
    </g>
    <g>
      <path
        className="background"
        id="sdg_two"
        d="M893.07,48.67c91,30,167,104,167,104l-189,207c-32-30-79-50-79-50L893.07,48.67Z"
        fill="#dda63a"
        fillOpacity="0.8"
      />
      <path
        d="M907.28,202.89v-8.75l27.07-28.05c2.89-3.05,5.28-5.72,7.17-8.03,1.89-2.3,3.3-4.5,4.24-6.58,.94-2.08,1.41-4.3,1.41-6.64,0-2.66-.62-4.95-1.88-6.89-1.25-1.94-2.96-3.44-5.12-4.49-2.16-1.05-4.6-1.58-7.3-1.58-2.87,0-5.37,.59-7.5,1.76-2.14,1.17-3.78,2.83-4.92,4.96-1.15,2.14-1.72,4.64-1.72,7.5h-11.52c0-4.87,1.12-9.13,3.36-12.77,2.24-3.65,5.31-6.48,9.22-8.5,3.91-2.02,8.35-3.03,13.32-3.03s9.46,1,13.3,2.99c3.84,1.99,6.84,4.7,9,8.12,2.16,3.42,3.24,7.29,3.24,11.58,0,2.97-.55,5.87-1.66,8.71-1.11,2.84-3.03,6-5.76,9.47s-6.54,7.69-11.41,12.64l-15.9,16.64v.59h36.02v10.35h-52.66Z"
        fill="#f3f4ff"
      />
    </g>
    <g>
      <path
        className="background"
        id="sdg_three"
        d="M1092.95,181.53c73.37,61.63,116.48,158.55,116.48,158.55l-252.33,122.07c-18.58-39.73-54.8-75.75-54.8-75.75l190.65-204.88Z"
        fill="#4c9f38"
        fillOpacity="0.8"
      />
      <path
        d="M1089.14,347.99c-5.37,0-10.15-.92-14.36-2.77-4.21-1.85-7.53-4.42-9.96-7.71-2.44-3.29-3.74-7.12-3.93-11.46h12.27c.16,2.37,.96,4.42,2.4,6.15,1.45,1.73,3.34,3.07,5.68,4s4.95,1.41,7.81,1.41c3.15,0,5.94-.55,8.38-1.64,2.43-1.09,4.34-2.62,5.72-4.59,1.38-1.97,2.07-4.24,2.07-6.82s-.68-5.04-2.05-7.09c-1.37-2.04-3.36-3.65-5.98-4.82s-5.78-1.76-9.47-1.76h-6.76v-9.84h6.76c2.97,0,5.58-.53,7.83-1.6,2.25-1.07,4.02-2.56,5.29-4.47,1.28-1.91,1.91-4.16,1.91-6.74s-.55-4.63-1.66-6.46c-1.11-1.84-2.67-3.27-4.69-4.32-2.02-1.04-4.39-1.56-7.13-1.56s-5.03,.48-7.29,1.43c-2.25,.95-4.08,2.3-5.49,4.06s-2.16,3.86-2.27,6.31h-11.68c.13-4.32,1.41-8.12,3.85-11.41,2.43-3.28,5.66-5.85,9.67-7.7,4.01-1.85,8.46-2.77,13.36-2.77s9.56,1,13.3,2.99c3.74,1.99,6.63,4.64,8.67,7.95,2.04,3.31,3.05,6.93,3.03,10.86,.03,4.48-1.22,8.28-3.73,11.41-2.51,3.12-5.85,5.22-10.02,6.29v.62c5.31,.81,9.43,2.92,12.36,6.33,2.93,3.41,4.38,7.64,4.36,12.7,.03,4.4-1.19,8.35-3.65,11.84-2.46,3.49-5.81,6.23-10.06,8.22-4.25,1.99-9.1,2.99-14.57,2.99Z"
        fill="#f3f4ff"
      />
    </g>
    <g>
      <path
        className="background"
        id="sdg_four"
        d="M1224.24,370.43c47.65,83.13,54.75,188.96,54.75,188.96l-278.93,27.71c-3.76-43.7-25.36-89.99-25.36-89.99l249.55-126.68Z"
        fill="#c5192d"
        fillOpacity="0.8"
      />
      <path
        d="M1149.6,509.27v-9.77l34.57-54.61h7.7v14.38h-4.88l-24.73,39.14v.62h47.38v10.23h-60.04Zm37.93,15.62v-18.59l.08-4.45v-56.95h11.45v80h-11.52Z"
        fill="#f3f4ff"
      />
    </g>
    <g>
      <path
        className="background"
        id="sdg_five"
        d="M1281.82,597.64c14.23,94.76-17.59,195.95-17.59,195.95l-269.96-75.44c12.36-42.09,9.04-93.06,9.04-93.06l278.51-27.45Z"
        fill="#ff3a21"
        fillOpacity="0.8"
      />
      <path
        d="M1200.69,731.99c-4.9,0-9.29-.94-13.18-2.83-3.89-1.89-7-4.49-9.32-7.79-2.32-3.31-3.55-7.08-3.71-11.33h11.72c.29,3.44,1.81,6.26,4.57,8.48,2.76,2.21,6.07,3.32,9.92,3.32,3.07,0,5.8-.71,8.18-2.13,2.38-1.42,4.26-3.38,5.62-5.88s2.05-5.35,2.05-8.55-.7-6.16-2.11-8.71c-1.41-2.55-3.34-4.56-5.8-6.02-2.46-1.46-5.28-2.2-8.46-2.23-2.42,0-4.86,.42-7.3,1.25-2.45,.83-4.43,1.93-5.94,3.28l-11.05-1.64,4.49-40.31h43.98v10.35h-33.95l-2.54,22.38h.47c1.56-1.51,3.64-2.77,6.23-3.79,2.59-1.02,5.37-1.52,8.34-1.52,4.87,0,9.21,1.16,13.03,3.48,3.81,2.32,6.82,5.48,9.02,9.47,2.2,4,3.29,8.59,3.26,13.77,.03,5.18-1.14,9.8-3.5,13.87-2.36,4.06-5.61,7.26-9.77,9.59-4.15,2.33-8.91,3.5-14.28,3.5Z"
        fill="#f3f4ff"
      />
    </g>
    <g>
      <path
        className="background"
        id="sdg_six"
        d="M1252.2,831.71c-22.55,93.13-90.16,174.86-90.16,174.86l-221.6-171.65c27.32-34.32,43.45-82.78,43.45-82.78l268.31,79.57Z"
        fill="#26bde2"
        fillOpacity="0.8"
      />
      <path
        d="M1143.21,924.99c-3.57-.05-7.08-.7-10.53-1.95-3.45-1.25-6.58-3.33-9.39-6.25-2.81-2.92-5.06-6.84-6.74-11.76s-2.52-11.07-2.52-18.44c0-6.98,.7-13.18,2.09-18.59,1.39-5.42,3.4-9.99,6.04-13.73,2.63-3.74,5.81-6.58,9.53-8.54,3.72-1.95,7.9-2.93,12.54-2.93s9,.94,12.7,2.81c3.7,1.88,6.7,4.47,9,7.77,2.3,3.31,3.77,7.07,4.39,11.29h-11.91c-.81-3.33-2.41-6.05-4.8-8.16-2.4-2.11-5.52-3.16-9.38-3.16-5.86,0-10.42,2.55-13.69,7.66-3.27,5.1-4.92,12.2-4.94,21.29h.59c1.38-2.27,3.08-4.2,5.1-5.8,2.02-1.6,4.28-2.84,6.8-3.71,2.51-.87,5.16-1.31,7.95-1.31,4.63,0,8.83,1.13,12.6,3.38,3.76,2.25,6.76,5.36,9,9.32,2.24,3.96,3.36,8.49,3.36,13.59s-1.15,9.73-3.46,13.87-5.54,7.42-9.71,9.82c-4.17,2.41-9.04,3.59-14.61,3.54Zm-.04-10.16c3.07,0,5.82-.75,8.24-2.27,2.42-1.51,4.34-3.54,5.74-6.09,1.41-2.55,2.11-5.4,2.11-8.55s-.68-5.87-2.05-8.4c-1.37-2.53-3.24-4.53-5.62-6.02s-5.1-2.23-8.14-2.23c-2.32,0-4.46,.44-6.43,1.33-1.97,.89-3.69,2.11-5.18,3.67s-2.65,3.35-3.5,5.37c-.85,2.02-1.27,4.15-1.27,6.39,0,3,.7,5.77,2.09,8.32,1.39,2.55,3.31,4.6,5.74,6.15,2.43,1.55,5.19,2.32,8.26,2.32Z"
        fill="#f3f4ff"
      />
    </g>
    <g>
      <path
        className="background"
        id="sdg_seven"
        d="M1145.4,1037.01c-54.27,78.97-146.58,131.22-146.58,131.22l-145.83-239.38c37.76-22.33,70.11-61.85,70.11-61.85l222.3,170.01Z"
        fill="#fcc30b"
        fillOpacity="0.8"
      />
      <path d="M1009.98,1091.89l34.92-69.06v-.59h-40.39v-10.35h52.89v10.7l-34.8,69.3h-12.62Z" fill="#f3f4ff" />
    </g>
    <g>
      <path
        className="background"
        id="sdg_eight"
        d="M969.78,1187.54c-78.02,55.63-182.64,73.14-182.64,73.14l-55.11-274.83c43.12-8.06,87.04-34.12,87.04-34.12l150.7,235.82Z"
        fill="#a21942"
        fillOpacity="0.8"
      />
      <path
        d="M841.32,1189.99c-5.6,0-10.54-.96-14.82-2.89-4.28-1.93-7.64-4.58-10.06-7.97-2.42-3.38-3.62-7.24-3.59-11.56-.03-3.38,.67-6.5,2.09-9.36,1.42-2.85,3.35-5.23,5.8-7.15,2.45-1.91,5.18-3.13,8.2-3.65v-.47c-3.98-.96-7.17-3.1-9.57-6.41-2.4-3.31-3.58-7.11-3.55-11.41-.03-4.09,1.06-7.74,3.26-10.96,2.2-3.22,5.23-5.75,9.08-7.6,3.85-1.85,8.24-2.77,13.16-2.77s9.22,.93,13.07,2.79c3.84,1.86,6.87,4.4,9.08,7.62,2.21,3.22,3.33,6.86,3.36,10.92-.03,4.3-1.25,8.1-3.67,11.41-2.42,3.31-5.57,5.44-9.45,6.41v.47c2.99,.52,5.7,1.74,8.11,3.65,2.41,1.91,4.34,4.3,5.78,7.15s2.18,5.97,2.21,9.36c-.03,4.32-1.25,8.18-3.67,11.56-2.42,3.39-5.78,6.04-10.06,7.97-4.28,1.93-9.2,2.89-14.75,2.89Zm0-9.88c3.31,0,6.17-.55,8.59-1.66,2.42-1.11,4.3-2.66,5.62-4.65s2-4.33,2.03-7.01c-.03-2.79-.75-5.25-2.17-7.38-1.42-2.13-3.34-3.81-5.76-5.04-2.42-1.22-5.2-1.84-8.32-1.84s-5.95,.61-8.4,1.84c-2.45,1.22-4.38,2.9-5.78,5.04-1.41,2.14-2.1,4.6-2.07,7.38-.03,2.68,.62,5.02,1.93,7.01,1.31,1.99,3.2,3.54,5.64,4.65,2.45,1.11,5.34,1.66,8.67,1.66Zm0-37.23c2.66,0,5.01-.53,7.07-1.6,2.06-1.07,3.68-2.55,4.86-4.45,1.18-1.9,1.79-4.13,1.82-6.68-.03-2.5-.62-4.69-1.78-6.56-1.16-1.88-2.77-3.33-4.82-4.36-2.06-1.03-4.44-1.54-7.15-1.54s-5.18,.51-7.25,1.54c-2.07,1.03-3.68,2.48-4.82,4.36-1.15,1.88-1.71,4.06-1.68,6.56-.03,2.55,.55,4.78,1.72,6.68,1.17,1.9,2.79,3.39,4.86,4.45,2.07,1.07,4.46,1.6,7.17,1.6Z"
        fill="#f3f4ff"
      />
    </g>
    <g>
      <path
        className="background"
        id="sdg_nine"
        d="M746.26,1271.52c-93.27,21.96-196.73-1.43-196.73-1.43l53-275.25c42.96,8.86,93.48,1.36,93.48,1.36l50.24,275.31Z"
        fill="#fd6925"
        fillOpacity="0.8"
      />
      <path
        d="M652.89,1145.8c3.57,.03,7.08,.68,10.55,1.95,3.46,1.28,6.59,3.36,9.39,6.25,2.8,2.89,5.04,6.79,6.72,11.7,1.68,4.91,2.53,11.01,2.56,18.3,0,7.01-.7,13.24-2.11,18.69-1.41,5.46-3.42,10.06-6.04,13.81s-5.79,6.6-9.51,8.55c-3.72,1.95-7.92,2.93-12.58,2.93s-9-.94-12.7-2.81c-3.7-1.88-6.71-4.47-9.02-7.79-2.32-3.32-3.76-7.14-4.34-11.46h11.91c.78,3.44,2.38,6.22,4.79,8.34,2.41,2.12,5.53,3.18,9.36,3.18,5.86,0,10.43-2.56,13.71-7.68s4.93-12.27,4.96-21.46h-.62c-1.35,2.24-3.04,4.17-5.06,5.78-2.02,1.62-4.28,2.87-6.78,3.75-2.5,.89-5.17,1.33-8.01,1.33-4.61,0-8.8-1.13-12.58-3.4-3.78-2.27-6.78-5.38-9.02-9.34-2.24-3.96-3.36-8.48-3.36-13.55s1.15-9.63,3.46-13.75c2.3-4.11,5.53-7.38,9.69-9.79,4.15-2.41,9.03-3.59,14.63-3.54Zm.04,10.16c-3.05,0-5.79,.75-8.22,2.25-2.44,1.5-4.36,3.52-5.76,6.05s-2.11,5.36-2.11,8.46,.68,5.91,2.05,8.42c1.37,2.51,3.24,4.51,5.62,5.98,2.38,1.47,5.11,2.21,8.18,2.21,2.29,0,4.43-.44,6.41-1.33,1.98-.88,3.71-2.12,5.2-3.69,1.48-1.58,2.64-3.37,3.48-5.37,.83-2,1.25-4.11,1.25-6.33,0-2.94-.7-5.68-2.09-8.2-1.39-2.53-3.3-4.56-5.72-6.11-2.42-1.55-5.18-2.32-8.28-2.32Z"
        fill="#f3f4ff"
      />
    </g>
    <g>
      <path
        className="background"
        id="sdg_ten"
        d="M509.54,1265.1c-94.93-12.99-183.09-71.98-183.09-71.98l148.31-237.85c36.91,23.7,86.76,34.84,86.76,34.84l-51.98,274.99Z"
        fill="#dd1367"
        fillOpacity="0.8"
      />
      <g>
        <path d="M425.64,1102.89v80h-12.11v-67.89h-.47l-19.14,12.5v-11.56l19.96-13.05h11.76Z" fill="#f3f4ff" />
        <path
          d="M475.13,1184.22c-6.17-.03-11.45-1.65-15.82-4.88-4.38-3.23-7.72-7.93-10.04-14.1-2.32-6.17-3.48-13.61-3.48-22.3s1.17-16.08,3.5-22.23c2.33-6.15,5.69-10.83,10.08-14.06,4.39-3.23,9.64-4.84,15.76-4.84s11.37,1.62,15.74,4.86,7.73,7.93,10.06,14.06c2.33,6.13,3.5,13.54,3.5,22.21s-1.16,16.17-3.48,22.32c-2.32,6.16-5.66,10.86-10.04,14.1s-9.64,4.86-15.78,4.86Zm0-10.43c5.42,0,9.65-2.64,12.71-7.93,3.06-5.29,4.59-12.93,4.59-22.93,0-6.64-.7-12.26-2.09-16.86-1.39-4.6-3.39-8.09-5.98-10.47-2.59-2.38-5.67-3.57-9.24-3.57-5.39,0-9.62,2.66-12.7,7.97-3.07,5.31-4.62,12.96-4.65,22.93,0,6.67,.7,12.3,2.09,16.89,1.39,4.6,3.38,8.07,5.96,10.43,2.58,2.36,5.68,3.54,9.3,3.54Z"
          fill="#f3f4ff"
        />
      </g>
    </g>
    <g>
      <path
        className="background"
        id="sdg_eleven"
        d="M290.94,1172.08c-83.99-46.11-145.21-132.74-145.21-132.74l223.61-169.02c25.99,35.34,68.55,63.58,68.55,63.58l-146.95,238.18Z"
        fill="#fd9d24"
        fillOpacity="0.8"
      />
      <g>
        <path d="M260.64,996.89v80h-12.11v-67.89h-.47l-19.14,12.5v-11.56l19.96-13.05h11.76Z" fill="#f3f4ff" />
        <path d="M312.63,996.89v80h-12.11v-67.89h-.47l-19.14,12.5v-11.56l19.96-13.05h11.76Z" fill="#f3f4ff" />
      </g>
    </g>
    <g>
      <path
        className="background"
        id="sdg_twelve"
        d="M120.67,1006.96c-61.87-73.17-87.94-175.99-87.94-175.99l269.36-77.57c11.58,42.31,41.18,83.94,41.18,83.94l-222.6,169.62Z"
        fill="#bf8b2e"
        fillOpacity="0.8"
      />
      <g>
        <path d="M130.64,828.89v80h-12.11v-67.89h-.47l-19.14,12.5v-11.56l19.96-13.05h11.76Z" fill="#f3f4ff" />
        <path
          d="M152.28,908.89v-8.75l27.07-28.05c2.89-3.05,5.28-5.72,7.17-8.03,1.89-2.3,3.3-4.5,4.24-6.58,.94-2.08,1.41-4.3,1.41-6.64,0-2.66-.62-4.95-1.88-6.89-1.25-1.94-2.96-3.44-5.12-4.49-2.16-1.05-4.6-1.58-7.3-1.58-2.87,0-5.37,.59-7.5,1.76-2.14,1.17-3.78,2.83-4.92,4.96-1.15,2.14-1.72,4.64-1.72,7.5h-11.52c0-4.87,1.12-9.13,3.36-12.77,2.24-3.65,5.31-6.48,9.22-8.5,3.91-2.02,8.35-3.03,13.32-3.03s9.46,1,13.3,2.99c3.84,1.99,6.84,4.7,9,8.12,2.16,3.42,3.24,7.29,3.24,11.58,0,2.97-.55,5.87-1.66,8.71-1.11,2.84-3.03,6-5.76,9.47s-6.54,7.69-11.41,12.64l-15.9,16.64v.59h36.02v10.35h-52.66Z"
          fill="#f3f4ff"
        />
      </g>
    </g>
    <g>
      <path
        className="background"
        id="sdg_thirteen"
        d="M21.76,791.15C-9.96,700.73,2.35,595.37,2.35,595.37l279.31,23.57c-4.26,43.66,8.55,93.1,8.55,93.1L21.76,791.15Z"
        fill="#3f7e44"
        fillOpacity="0.8"
      />
      <g>
        <path d="M77.64,641.89v80h-12.11v-67.89h-.47l-19.14,12.5v-11.56l19.96-13.05h11.76Z" fill="#f3f4ff" />
        <path
          d="M127.13,722.99c-5.37,0-10.15-.92-14.36-2.77-4.21-1.85-7.53-4.42-9.96-7.71-2.44-3.29-3.74-7.12-3.93-11.46h12.27c.16,2.37,.96,4.42,2.4,6.15,1.45,1.73,3.34,3.07,5.68,4s4.95,1.41,7.81,1.41c3.15,0,5.94-.55,8.38-1.64,2.43-1.09,4.34-2.62,5.72-4.59,1.38-1.97,2.07-4.24,2.07-6.82s-.68-5.04-2.05-7.09c-1.37-2.04-3.36-3.65-5.98-4.82s-5.78-1.76-9.47-1.76h-6.76v-9.84h6.76c2.97,0,5.58-.53,7.83-1.6,2.25-1.07,4.02-2.56,5.29-4.47,1.28-1.91,1.91-4.16,1.91-6.74s-.55-4.63-1.66-6.46c-1.11-1.84-2.67-3.27-4.69-4.32-2.02-1.04-4.39-1.56-7.13-1.56s-5.03,.48-7.29,1.43c-2.25,.95-4.08,2.3-5.49,4.06s-2.16,3.86-2.27,6.31h-11.68c.13-4.32,1.41-8.12,3.85-11.41,2.43-3.28,5.66-5.85,9.67-7.7,4.01-1.85,8.46-2.77,13.36-2.77s9.56,1,13.3,2.99c3.74,1.99,6.63,4.64,8.67,7.95,2.04,3.31,3.05,6.93,3.03,10.86,.03,4.48-1.22,8.28-3.73,11.41-2.51,3.12-5.85,5.22-10.02,6.29v.62c5.31,.81,9.43,2.92,12.36,6.33,2.93,3.41,4.38,7.64,4.36,12.7,.03,4.4-1.19,8.35-3.65,11.84-2.46,3.49-5.81,6.23-10.06,8.22-4.25,1.99-9.1,2.99-14.57,2.99Z"
          fill="#f3f4ff"
        />
      </g>
    </g>
    <g>
      <path
        className="background"
        id="sdg_fourteen"
        d="M7.58,553.91c3.65-95.75,53.73-189.26,53.73-189.26l251.22,124.34c-19.97,39.05-26.19,89.75-26.19,89.75L7.58,553.91Z"
        fill="#0a97d9"
        fillOpacity="0.8"
      />
      <g>
        <path d="M100.64,444.89v80h-12.11v-67.89h-.47l-19.14,12.5v-11.56l19.96-13.05h11.76Z" fill="#f3f4ff" />
        <path
          d="M120.6,509.27v-9.77l34.57-54.61h7.7v14.38h-4.88l-24.73,39.14v.62h47.38v10.23h-60.04Zm37.93,15.62v-18.59l.08-4.45v-56.95h11.45v80h-11.52Z"
          fill="#f3f4ff"
        />
      </g>
    </g>
    <g>
      <path
        className="background"
        id="sdg_fifteen"
        d="M80.05,331.14c38.02-87.95,118.51-157.03,118.51-157.03l189.27,206.75c-32.74,29.19-56.86,74.21-56.86,74.21l-250.93-123.93Z"
        fill="#56c02b"
        fillOpacity="0.8"
      />
      <g>
        <path d="M197.64,266.89v80h-12.11v-67.89h-.47l-19.14,12.5v-11.56l19.96-13.05h11.76Z" fill="#f3f4ff" />
        <path
          d="M245.68,347.99c-4.9,0-9.29-.94-13.18-2.83-3.89-1.89-7-4.49-9.32-7.79-2.32-3.31-3.55-7.08-3.71-11.33h11.72c.29,3.44,1.81,6.26,4.57,8.48,2.76,2.21,6.07,3.32,9.92,3.32,3.07,0,5.8-.71,8.18-2.13,2.38-1.42,4.26-3.38,5.62-5.88s2.05-5.35,2.05-8.55-.7-6.16-2.11-8.71c-1.41-2.55-3.34-4.56-5.8-6.02-2.46-1.46-5.28-2.2-8.46-2.23-2.42,0-4.86,.42-7.3,1.25-2.45,.83-4.43,1.93-5.94,3.28l-11.05-1.64,4.49-40.31h43.98v10.35h-33.95l-2.54,22.38h.47c1.56-1.51,3.64-2.77,6.23-3.79,2.59-1.02,5.37-1.52,8.34-1.52,4.87,0,9.21,1.16,13.03,3.48,3.81,2.32,6.82,5.48,9.02,9.47,2.2,4,3.29,8.59,3.26,13.77,.03,5.18-1.14,9.8-3.5,13.87-2.36,4.06-5.61,7.26-9.77,9.59-4.15,2.33-8.91,3.5-14.28,3.5Z"
          fill="#f3f4ff"
        />
      </g>
    </g>
    <g>
      <path
        className="background"
        id="sdg_sixteen"
        d="M230.13,150.78c67.69-67.82,167.95-102.47,167.95-102.47l100.01,261.86c-41.18,15.11-80.16,48.11-80.16,48.11L230.13,150.78Z"
        fill="#00689d"
        fillOpacity="0.8"
      />
      <g>
        <path d="M339.64,138.89v80h-12.11v-67.89h-.47l-19.14,12.5v-11.56l19.96-13.05h11.76Z" fill="#f3f4ff" />
        <path
          d="M389.21,219.99c-3.57-.05-7.08-.7-10.53-1.95-3.45-1.25-6.58-3.33-9.39-6.25-2.81-2.92-5.06-6.84-6.74-11.76s-2.52-11.07-2.52-18.44c0-6.98,.7-13.18,2.09-18.59,1.39-5.42,3.4-9.99,6.04-13.73,2.63-3.74,5.81-6.58,9.53-8.54,3.72-1.95,7.9-2.93,12.54-2.93s9,.94,12.7,2.81c3.7,1.88,6.7,4.47,9,7.77,2.3,3.31,3.77,7.07,4.39,11.29h-11.91c-.81-3.33-2.41-6.05-4.8-8.16-2.4-2.11-5.52-3.16-9.38-3.16-5.86,0-10.42,2.55-13.69,7.66-3.27,5.1-4.92,12.2-4.94,21.29h.59c1.38-2.27,3.08-4.2,5.1-5.8,2.02-1.6,4.28-2.84,6.8-3.71,2.51-.87,5.16-1.31,7.95-1.31,4.63,0,8.83,1.13,12.6,3.38,3.76,2.25,6.76,5.36,9,9.32,2.24,3.96,3.36,8.49,3.36,13.59s-1.15,9.73-3.46,13.87-5.54,7.42-9.71,9.82c-4.17,2.41-9.04,3.59-14.61,3.54Zm-.04-10.16c3.07,0,5.82-.75,8.24-2.27,2.42-1.51,4.34-3.54,5.74-6.09,1.41-2.55,2.11-5.4,2.11-8.55s-.68-5.87-2.05-8.4c-1.37-2.53-3.24-4.53-5.62-6.02s-5.1-2.23-8.14-2.23c-2.32,0-4.46,.44-6.43,1.33-1.97,.89-3.69,2.11-5.18,3.67s-2.65,3.35-3.5,5.37c-.85,2.02-1.27,4.15-1.27,6.39,0,3,.7,5.77,2.09,8.32,1.39,2.55,3.31,4.6,5.74,6.15,2.43,1.55,5.19,2.32,8.26,2.32Z"
          fill="#f3f4ff"
        />
      </g>
    </g>
    <g>
      <path
        className="background"
        id="sdg_seventeen"
        d="M431.63,36.63C519.05-2.6,625.07,.76,625.07,.76l.09,280.3c-43.86-.56-92.05,16.37-92.05,16.37L431.63,36.63Z"
        fill="#19486a"
        fillOpacity="0.8"
      />
      <g>
        <path d="M522.64,61.89v80h-12.11V74h-.47l-19.14,12.5v-11.56l19.96-13.05h11.76Z" fill="#f3f4ff" />
        <path d="M546.97,141.89l34.92-69.06v-.59h-40.39v-10.35h52.89v10.7l-34.8,69.3h-12.62Z" fill="#f3f4ff" />
      </g>
    </g>
  </svg>
);
